import Stack from "@mui/material/Stack";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { MineBtn } from "../buttons/MineBtn";
import { SettingBtn } from "../buttons/SettingBtn";
import React from "react";
import MenuIcon from "@mui/icons-material/Menu";
import AssignmentIcon from "@mui/icons-material/Assignment";
import LanguageIcon from "@mui/icons-material/Language";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import SchoolIcon from "@mui/icons-material/School";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import Toggle from "../toggle/Toggle";

interface NavigationItem {
  label: string;
  link: string;
  icon: JSX.Element;
}

export const navigationMenu: NavigationItem[] = [
  { label: "ABOUT", link: "/#about", icon: <AssignmentIcon /> },
  { label: "LANGUAGES", link: "/#languages", icon: <LanguageIcon /> },
  { label: "SKILLS", link: "/#skills", icon: <FormatListBulletedIcon /> },
  { label: "EDUCATION", link: "/#education", icon: <SchoolIcon /> },
  { label: "EXPERIENCE", link: "/#experience", icon: <HistoryEduIcon /> },
  { label: "PROJECTS", link: "/#projects", icon: <AccountTreeIcon /> },
];

export const Header = () => {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
      <List>
        {navigationMenu?.map((item, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton href={item?.link || ""}>
              <ListItemIcon>{item?.icon}</ListItemIcon>
              <ListItemText primary={item?.label || ""} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <Box
        sx={{
          height: {
            xs: "3.5vh",
            sm: "4vh",
            md: "4.5vh",
            lg: "5vh",
          },

          bgcolor: "transparent",
          mt: "32px",
          display: "flex",

          justifyContent: "space-between",
          mr: {
            xs: "15px",
            sm: "18px",
            md: "20px",
            lg: "22px",
          },
          ml: {
            xs: "15px",
            sm: "18px",
            md: "20px",
            lg: "22px",
          },
          "& .setting-btn": {
            height: "40px",
          },
          "& .mine-btn": {
            height: "40px",
            fontSize: {
              xs: 7,
              sm: 9,
              md: 12,
              lg: 15,
            },
          },
        }}
      >
        <Toggle />
        {true && (
          <Stack
            sx={{
              display: {
                xs: "none",
                sm: "none",
                md: "flex",
                lg: "flex",
              },
            }}
            spacing={2}
            direction="row"
          >
            {navigationMenu.map((el) => (
              <MineBtn text={el?.label || ""} link={el?.link || ""} />
            ))}
          </Stack>
        )}
        {true && (
          <SettingBtn
            sx={{
              display: {
                xs: "flex",
                sm: "flex",
                md: "none",
                lg: "none",
              },
            }}
            onClick={toggleDrawer(true)}
            icon={<MenuIcon />}
          />
        )}

        <Drawer
          sx={{
            "& .MuiDrawer-paper": {
              borderBottomRightRadius: "20px",
              borderTopRightRadius: "20px",
              backgroundColor: "var(--c-bg-content-color)",
              "& .MuiListItem-root": {
                color: "var(--c-text-color)",
                fontSize: "8px",
                fontWeight: "bold",
              },
              "& .MuiSvgIcon-root": {
                color: "var(--c-text-color)",
              },
            },
          }}
          open={open}
          onClose={toggleDrawer(false)}
        >
          {DrawerList}
        </Drawer>
      </Box>
    </>
  );
};
